import { useQuery } from "react-query";
import { UserAccountsService } from "../gen/clients/llts";
import { useUserSession } from "./useUserSession";

/**
 * Custom hook to fetch the current user's account.
 *
 * The query is keyed on `username` (matching the key used elsewhere, e.g. HomePage)
 * so all observers share a single cached result and a single network request.
 */
export const useUserAccount = () => {
  const { username } = useUserSession();

  return useQuery(["getUserAccount", username], {
    queryFn: UserAccountsService.getUserAccount,
    enabled: !!username
  });
};
